import BuildPeerGroups from "../components/PeerGroup/BuildPeerGroups";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, KeyValue, Query } from "../interfaces";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.peerGroup,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateUi: (uiField: string, uiValue: string | KeyValue[] | string[]) => {
      dispatch(actions.updateUi(uiField, uiValue));
      dispatch(actions.searchPush());
    },
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BuildPeerGroups);
